import api from '../utils/api';

export default {
    namespaced: true,
    state: {
        filter: 'all',
        consents: [],
        consent: undefined,
    },
    getters: {},
    /* eslint-disable no-param-reassign */
    mutations: {
        LIST(state, data) {
            state.consents = data;
        },
        CONSENT(state, data) {
            state.consent = data;
        },
        FILTER(state, value) {
            state.filter = value;
        },
    },
    actions: {
        LIST_ALL(context) {
            const filter = context.state.filter;
            const issuer = this.getters['auth/organisationId'];
            return api
                .get(`/${issuer}/consents?filter=${filter}`)
                .then(response => context.commit('LIST', response.data))
                .catch(error => context.commit('errors/ADD', error, { root: true }));
        },
        LOAD_CONSENT(context, { issuer, intent, user }) {
            return api
                .get(`/${issuer}/intents/${intent}/users/${user}/consent`)
                .then(response => context.commit('CONSENT', response.data))
                .catch(error => context.commit('errors/ADD', error, { root: true }));
        },
        LIST_FILTER(context, filter) {
            if (filter !== context.state.filter) {
                /* eslint-disable no-console */
                console.log('filter changed from ', context.state.filter, ' to ', filter);
                context.commit('FILTER', filter);
                const issuer = this.getters['auth/organisationId'];
                return api
                    .get(`/${issuer}/consents?filter=${filter}`)
                    .then(response => context.commit('LIST', response.data))
                    .catch(error => context.commit('errors/ADD', error, { root: true }));
            }

            /* eslint-disable no-console */
            console.log('filter was not changed from ', filter);
            return null;
        },
    },
};



// WEBPACK FOOTER //
// ./src/store/consents.js